import { render, staticRenderFns } from "./FormPrestamo.vue?vue&type=template&id=1d624a6c&"
import script from "./FormPrestamo.vue?vue&type=script&lang=js&"
export * from "./FormPrestamo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports